'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validatebaseURL = exports.validatePermissionReducer = exports.validateActionCode = exports.validatePropNamespace = exports.validatePermission = exports.validateFunctionCode = exports.validateTimerInterval = exports.validateActionFrom = exports.error = exports.getParentFnCode = exports.getFnCode = exports.getActionCode = exports.getModuleCode = exports.isCodeEqual = exports.isContainArray = exports.toArray = exports.DEFAULT_TIME_INTERVAL = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.isJsonString = isJsonString;

var _lodash = require('lodash');

var _index = require('./symbols/index');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IS_CALL_API = _index2.default.IS_CALL_API,
    IS_AXIOS = _index2.default.IS_AXIOS;

// min * sec * millisecond

var DEFAULT_TIME_INTERVAL = exports.DEFAULT_TIME_INTERVAL = 30 * 60 * 1000;

var toArray = exports.toArray = function toArray(code) {
  var currentCode = code;
  if (!(0, _lodash.isArray)(currentCode)) {
    currentCode = currentCode ? [currentCode] : [];
  }
  return currentCode;
};

var isContainArray = exports.isContainArray = function isContainArray(array) {
  return (0, _lodash.isArray)(array) && array.length > 0;
};

var isCodeEqual = exports.isCodeEqual = function isCodeEqual(currentCode, code) {
  return currentCode.toLowerCase() === code.toLowerCase();
};

var getModuleCode = exports.getModuleCode = function getModuleCode(permission, moduleCodes) {
  return (0, _lodash.find)(moduleCodes, function (code) {
    return isCodeEqual(code, permission.moduleCode);
  });
};

var getActionCode = exports.getActionCode = function getActionCode(permission, actionCodes) {
  return (0, _lodash.find)(actionCodes, function (code) {
    return isCodeEqual(code, permission.actionCode);
  });
};

var getFnCode = exports.getFnCode = function getFnCode(permission, functionCodes) {
  return (0, _lodash.find)(functionCodes, function (code) {
    return isCodeEqual(code, permission.functionCode);
  });
};

var getParentFnCode = exports.getParentFnCode = function getParentFnCode(permission, parentFunctionCodes) {
  return (0, _lodash.find)(parentFunctionCodes, function (code) {
    return isCodeEqual(code, permission.parentFunctionCode);
  });
};

var error = exports.error = function error(message) {
  throw new Error(message);
};

var validateActionFrom = exports.validateActionFrom = function validateActionFrom(from) {
  if (!from) {
    error('Missing parameter. From is required');
  }
  if ([IS_CALL_API, IS_AXIOS].indexOf(from) < 0) {
    var isCallApi = IS_CALL_API.toString();
    var isAxios = IS_AXIOS.toString();
    error('From must be ' + isCallApi + ' or ' + isAxios);
  }
};

var validateTimerInterval = exports.validateTimerInterval = function validateTimerInterval(timerInterval) {
  if (typeof timerInterval !== 'number') {
    error('Interval must be a number');
  }
};

var validateFunctionCode = exports.validateFunctionCode = function validateFunctionCode(functionCode) {
  if (!functionCode) {
    error('Missing parameter. FunctionCode is required');
  }
  if (typeof functionCode !== 'string' && !(0, _lodash.isArray)(functionCode)) {
    error('FunctionCode must be a string or an array');
  }
};

var validatePermission = exports.validatePermission = function validatePermission(permission) {
  if (!permission) {
    error('Missing parameter. Permission is required');
  }
  if (typeof permission !== 'string') {
    error('Permission must be a string');
  }
};

var validatePropNamespace = exports.validatePropNamespace = function validatePropNamespace(propNamespace) {
  if (propNamespace && typeof propNamespace !== 'string') {
    error('If propNamespace exist. Must be string');
  }
};

var validateActionCode = exports.validateActionCode = function validateActionCode(actionCode) {
  if (actionCode && typeof actionCode !== 'string' && !(0, _lodash.isArray)(actionCode)) {
    error('If actionCode exist. Must be a string or an array');
  }
};

var validatePermissionReducer = exports.validatePermissionReducer = function validatePermissionReducer(permissionReducer) {
  if (!permissionReducer) {
    error('If actionCode exist. Must be a string or an array');
  }
};

var validatebaseURL = exports.validatebaseURL = function validatebaseURL(baseURL) {
  if (baseURL && typeof baseURL !== 'string') {
    error('If baseURL exist. Must be string');
  }
};

function isJsonString(str) {
  try {
    var obj = JSON.parse(str);
    if (obj && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null) {
      return true;
    }
  } catch (err) {
    return false;
  }
  return false;
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@mayo/user-permissions/lib/utils.js
 ** module id = 253
 ** module chunks = 0
 **/